import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { useWebsiteSettings } from 'client/store'
import React from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/editor/store/website-settings/website-settings-selector'
import { CommonWebsitePageBody } from 'src/shared/entities/website-page-body'
import { WebsitePageInterface } from 'src/shared/types/website-entities'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

export interface WebsitePageBodyProps {
  entity: WebsitePageInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsitePageBody = ({ entity }: WebsitePageBodyProps) => {
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)
  const backgroundImage = getBackgroundImageStyleValue(
    background?.pageBackgroundPicture?.file,
  )

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={false}
      isMoveDownAllowed={false}
      isCopyAllowed={false}
      isRemoveAllowed={false}
      isSaveAllowed={false}
    >
      <CommonWebsitePageBody
        htmlAttrId={entity.htmlAttrId}
        contentWidth={layout?.contentWidth}
        backgroundImage={backgroundImage}
        background={
          background?.containerBackgroundColor ||
          background?.contentBackgroundColor
        }
        pageBackground={background?.pageBackgroundColor}
      >
        <ChildrenEntities
          id={entity.id}
          childIds={entity.childIds}
          type={entity.type}
        />
      </CommonWebsitePageBody>
    </BaseEntityNew>
  )
}
